import {
    useState,
    type FC
} from "react";
import {
    StyleSheet,
    View
} from "react-native";
import {
    NCoreUIKitTheme,
    Tabs
} from "ncore-ui-kit";
import {
    useDocsI18n
} from "../i18n";
import type {
    DocsTocItem
} from "../components/toc";
import {
    PUBLISHED_BLOCK_CATEGORIES,
    PUBLISHED_BLOCKS,
    type BlockEntry,
    getBlockPath,
    BLOCKS_PATH,
    BLOCKS
} from "../blocks";
import {
    PageHeader,
    Article
} from "../components/content";
import BlockFrame from "../components/blockFrame";

const stylesheet = StyleSheet.create({
    list: {
        flexDirection: "column"
    }
});

const createBlockPage = (block: BlockEntry): FC => {
    const BlockPage = () => {
        const {
            t
        } = useDocsI18n();

        return <Article>
            <PageHeader
                breadcrumbs={[
                    {
                        label: t("breadcrumb.docs"),
                        href: "/"
                    },
                    {
                        label: t("nav.sectionBlocks"),
                        href: BLOCKS_PATH
                    }
                ]}
                title={t(block.titleKey)}
                lead={t(block.leadKey)}
            />
            <BlockFrame
                block={block}
            />
        </Article>;
    };

    return BlockPage;
};

const BlocksIndexPage = () => {
    const {
        t
    } = useDocsI18n();

    const {
        spaces
    } = NCoreUIKitTheme.useContext();

    const [
        category,
        setCategory
    ] = useState("all");

    const visibleBlocks = PUBLISHED_BLOCKS.filter((block) => category === "all" || block.category === category);

    return <Article>
        <PageHeader
            breadcrumbs={[
                {
                    label: t("breadcrumb.docs"),
                    href: "/"
                }
            ]}
            title={t("nav.sectionBlocks")}
            lead={t("blocks.indexLead")}
        />
        <Tabs
            onValueChange={setCategory}
            value={category}
        >
            <Tabs.List
                title={t("blocks.category")}
            >
                <Tabs.Trigger
                    title={t("blocks.category.all")}
                    value="all"
                />
                {
                    PUBLISHED_BLOCK_CATEGORIES.map((item) => <Tabs.Trigger
                        title={t(`blocks.category.${item}`)}
                        value={item}
                        key={item}
                    />)
                }
            </Tabs.List>
        </Tabs>
        <View
            style={[
                stylesheet.list,
                {
                    gap: spaces.spacingXxl
                }
            ]}
        >
            {
                visibleBlocks.map((block) => <BlockFrame
                    isShowTitle={true}
                    key={block.id}
                    block={block}
                />)
            }
        </View>
    </Article>;
};

export const BLOCK_PAGES: Record<string, {
    getToc: () => Array<DocsTocItem>;
    Page: FC;
}> = Object.fromEntries(BLOCKS.map((block) => [
    getBlockPath(block.id),
    {
        Page: createBlockPage(block),
        getToc: () => []
    }
]));

export default BlocksIndexPage;
